import { Stack } from "@mui/material";
import React from "react";

const ActionItemWrapper = ({ children, onClick, props }) => {
  return (
    <>
      <Stack
        {...props}
        onClick={onClick}
        sx={{ cursor: "pointer" }}
        spacing={1}
        color="primary.main"
        p={1.5}
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        {children}
      </Stack>
    </>
  );
};

export default ActionItemWrapper;
